import { CancelFunctions } from 'components/common/types';
import { PolygonRequest, PolygonsResponse } from 'components/common/types/Polygon.types';
import { HTTP_METHODS, URLS } from './constants';
import createRequest from './request';

export const getPolygons = async (
  marketId: string,
  campaignId: string,
  cancelFunctions: CancelFunctions,
): Promise<PolygonsResponse> => {
  const { send, cancel } = createRequest({
    url: URLS().FETCH_CAMPAIGN_POLYGONS(marketId, campaignId),
    showLoader: true,
    method: HTTP_METHODS.GET,
  });

  if (cancelFunctions.FETCH_CAMPAIGN_POLYGONS) cancelFunctions.FETCH_CAMPAIGN_POLYGONS();
  cancelFunctions.FETCH_CAMPAIGN_POLYGONS = cancel;

  const result = await send();
  return result.data;
};

export const addLinePolygon = async (
  payload: {
    marketId: string;
    campaignId: string;
    lineId: string;
    polygonId: string;
    data: PolygonRequest;
  },
  cancelFunctions: CancelFunctions,
): Promise<void> => {
  const { marketId, campaignId, lineId, polygonId, data } = payload;

  const { send, cancel } = createRequest({
    url: URLS().CREATE_LINE_POLYGON(marketId, campaignId, lineId, polygonId),
    data,
    showLoader: true,
    method: HTTP_METHODS.POST,
  });

  if (cancelFunctions.CREATE_LINE_POLYGON) cancelFunctions.CREATE_LINE_POLYGON();
  cancelFunctions.CREATE_LINE_POLYGON = cancel;

  await send();
};

export const deleteLinePolygon = async (
  payload: {
    marketId: string;
    campaignId: string;
    lineId: string;
    polygonId: string;
  },
  cancelFunctions: CancelFunctions,
): Promise<void> => {
  const { marketId, campaignId, lineId, polygonId } = payload;

  const { send, cancel } = createRequest({
    url: URLS().DELETE_LINE_POLYGON(marketId, campaignId, lineId, polygonId),
    showLoader: true,
    method: HTTP_METHODS.DELETE,
  });

  if (cancelFunctions.DELETE_LINE_POLYGON) cancelFunctions.DELETE_LINE_POLYGON();
  cancelFunctions.DELETE_LINE_POLYGON = cancel;

  await send();
};
